/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { instanceOfFxIdApplicationHandlersAuthAuthenticateFromSocialSteamLoginOptions, FxIdApplicationHandlersAuthAuthenticateFromSocialSteamLoginOptionsFromJSONTyped, FxIdApplicationHandlersAuthAuthenticateFromSocialSteamLoginOptionsToJSON, } from './FxIdApplicationHandlersAuthAuthenticateFromSocialSteamLoginOptions';
export function FxIdWebFeaturesAuthAuthenticateFromSocialRequestSteamLoginFromJSON(json) {
    return FxIdWebFeaturesAuthAuthenticateFromSocialRequestSteamLoginFromJSONTyped(json, false);
}
export function FxIdWebFeaturesAuthAuthenticateFromSocialRequestSteamLoginFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    if (instanceOfFxIdApplicationHandlersAuthAuthenticateFromSocialSteamLoginOptions(json)) {
        return FxIdApplicationHandlersAuthAuthenticateFromSocialSteamLoginOptionsFromJSONTyped(json, true);
    }
    return {};
}
export function FxIdWebFeaturesAuthAuthenticateFromSocialRequestSteamLoginToJSON(json) {
    return FxIdWebFeaturesAuthAuthenticateFromSocialRequestSteamLoginToJSONTyped(json, false);
}
export function FxIdWebFeaturesAuthAuthenticateFromSocialRequestSteamLoginToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    if (instanceOfFxIdApplicationHandlersAuthAuthenticateFromSocialSteamLoginOptions(value)) {
        return FxIdApplicationHandlersAuthAuthenticateFromSocialSteamLoginOptionsToJSON(value);
    }
    return {};
}
//# sourceMappingURL=FxIdWebFeaturesAuthAuthenticateFromSocialRequestSteamLogin.js.map